export const iconFontAwesomeMoneyTengeSign = (
	<i className="fa-solid fa-tenge-sign"></i>
);
